import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { ThemeProvider } from "@mui/material";
import ContentBox from "src/components/ContentBox/ContentBox";
import { faqQuestions } from "src/media/texts/faq";
import { AccordionWrapper } from "./StillUnsure";
import MainButton from "src/components/buttons/mainbutton";
import theme from "src/styles/mainstyle";

export default function FAQ() {
  return (
    <ThemeProvider theme={theme}>
      <ContentBox title="" id={"how-it-works"}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ fontWeight: "bold", marginBottom: "20px" }}
            >
              FAQ
            </Typography>
            <Grid item xs={12} md={8}>
              {faqQuestions.map((item, index) => (
                <AccordionWrapper
                  key={index}
                  question={"• " + item.header}
                  answer={item.answer}
                  smallVersion={true}
                />
              ))}
            </Grid>
            <Grid item xs={12} md={4} sx={{ pt: 4 }}>
              <MainButton
                text="More questions?"
                onClick={() => {
                  window.location.href = "/faq#faq-main";
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
    </ThemeProvider>
  );
}
